import { format } from "date-fns";

export default (value) => {
  try {
    if (!value) return "";
    return format(new Date(value), "MM/dd/yyyy h:mm a");
  } catch (error) {
    if (error instanceof RangeError) {
      return "";
    }

    throw error;
  }
};
